import { BillingPlan, SocialTypeEnum } from '@frontend/sorghum/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { BILLING_PLAN } from '../apis';

async function getBillingPlan(
  socialType: SocialTypeEnum,
): Promise<BillingPlan[]> {
  return axios
    .get(`${BILLING_PLAN}`, {
      params: {
        socialType,
      },
    })
    .then((res) => res.data.data);
}

export function useGetBillingPlan(socialType: SocialTypeEnum | undefined) {
  // WHY: 原本 catch 把所有錯誤（含 401 token 過期）吞成空陣列，升級頁因此渲染
  // NT$0＋NaN% 且能繼續結帳（2026-09 客戶連買四次案）。改讓錯誤進 error 狀態由頁面處理。
  return useQuery<BillingPlan[]>({
    queryKey: ['get-billing-plan', { socialType }],
    queryFn: () => getBillingPlan(socialType as SocialTypeEnum),
    enabled: !!socialType,
    // 全域預設 useErrorBoundary: true 會把錯誤丟進 error boundary 白屏；
    // 這裡要把錯誤留在頁內（顯示載入失敗＋重試），所以關掉
    useErrorBoundary: false,
  });
}
